import React, { useEffect, useState } from 'react';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { Box, IconButton, Typography, TextField, List, ListItem, Checkbox, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { getCookies } from '../../../services/Cookies';
import SearchIcon from '@mui/icons-material/Search';
import InputAdornment from '@mui/material/InputAdornment';

export default function ShowSymbols({ onClose }) {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const clientId = getCookies("clientId");
    const { symbols } = useSelector(state => state.watchlist);

    const [hiddenSymbols, setHiddenSymbols] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");

    useEffect(() => {
        const stored = JSON.parse(localStorage.getItem(`hiddenSymbols_${clientId}`)) || [];
        setHiddenSymbols(stored);
    }, [clientId]);

    const handleSearch = (event) => {
        setSearchQuery(event.target.value.toLowerCase());
    };

    const handleToggleSymbol = (symbolId) => {
        const updated = hiddenSymbols.includes(symbolId)
            ? hiddenSymbols.filter(id => id !== symbolId)
            : [...hiddenSymbols, symbolId];
        setHiddenSymbols(updated);
    };

    const handleSave = () => {
        localStorage.setItem(`hiddenSymbols_${clientId}`, JSON.stringify(hiddenSymbols));
        window.dispatchEvent(new CustomEvent('hiddenSymbolsUpdated'));
        onClose();
    };


    const filteredSymbols = Object.values(symbols).filter(symbol =>
        symbol.isVisible &&
        symbol.isUsed &&
        symbol.name.toLowerCase().includes(searchQuery.toLowerCase())
    );


    return (
        <Box display="flex" flexDirection="column" height="100%" px={2} py={1}>
            <Box display="flex" alignItems="center" justifyContent="space-between">
                <Box display="flex" alignItems="center">
                    <IconButton onClick={() => onClose()}><ArrowBackIosNewIcon fontSize="small" /></IconButton>
                    <Typography fontSize={18} fontWeight={600} ml={1}>{t('showSymbols')}</Typography>
                </Box>
                <Button variant="contained" onClick={handleSave}>{t('save')}</Button>
            </Box>

            <TextField fullWidth variant="outlined" size="small" placeholder={t('symbolName')} onChange={handleSearch} sx={{ my: 2 }}
                InputProps={{ startAdornment: (<InputAdornment position="start"><SearchIcon fontSize="small" /></InputAdornment>), }}
            />

            <List sx={{ flexGrow: 1, overflow: 'auto' }}>
                {filteredSymbols?.map((symbol) => (
                    <ListItem key={symbol.id} dense button onClick={() => handleToggleSymbol(symbol.id)}>
                        <Checkbox edge="start" checked={!hiddenSymbols.includes(symbol.id)} tabIndex={-1} disableRipple />
                        <Typography>{symbol.name}</Typography>
                    </ListItem>
                ))}
            </List>

            {/* <Box mt="auto" py={2}>
                <Button variant="contained" fullWidth onClick={handleSave}>{t('save')}</Button>
            </Box> */}
        </Box>
    );
}
